import jwtDecode from "jwt-decode";
import React, { useState, useEffect, useCallback } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import instance from "../extras/baseUrl";
import splash from "../assets/loader.mp4";
import gif from "../assets/loader.gif";
import { CLIENT_US_URL } from "../extras/constants";
import axios from "axios";

const DiscFootballUs = () => {
  const [show, setShow] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const payload = urlParams.get("payload");

  const [verified, setVerified] = useState(false);

  const {
    unityProvider,
    isLoaded,
    loadingProgression,
    sendMessage,
    addEventListener,
    requestFullscreen,
    removeEventListener,
  } = useUnityContext({
    loaderUrl: "build/us-discFootball/Build 1.1 US.loader.js",
    dataUrl: "build/us-discFootball/Build 1.1 US.data",
    frameworkUrl: "build/us-discFootball/Build 1.1 US.framework.js",
    codeUrl: "build/us-discFootball/Build 1.1 US.wasm",
    productName: "My Game",
    productVersion: "1.0.0",
    companyName: "Developer",
  });

  // We'll round the loading progression to a whole number to represent the
  // percentage of the Unity Application that has loaded.
  const loadingPercentage = Math.round(loadingProgression * 100);

  // We'll use a state to store the device pixel ratio.
  const [devicePixelRatio, setDevicePixelRatio] = useState(
    window.devicePixelRatio
  );

  function iOS() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }

  const decodeToken = () => {
    const decoded = jwtDecode(payload);
    return decoded;
  };

  const verifyToken = async () => {
    const decoded = jwtDecode(token);

    try {
      const res = await instance.post("/clients/verify", {
        clientId: decoded?._id,
      });
      if (res.data?.status === "success") {
        setVerified(true);
      }
      console.log("Client Verified");
    } catch (err) {
      console.log(err);
    }
  };

  const handleApiClose = async (instanceId, winnerId) => {
    try {
      var form = new FormData();
      form.append("instanceId", instanceId);
      form.append("winnerId", winnerId);

      const res = await axios.post(CLIENT_US_URL, form, {
        headers: {
          Authorization:
            "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmdWxsTmFtZSI6InNoaXZhbnNodSIsInVzZXJOYW1lIjoic2hpdmFuc2h1IiwiaWQiOiI2NDY4YmMxOWI4NjYxMjk3MzRkNDhkZjAiLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE2ODU2MTM5MTl9.SmP4quVEGpjBnV9mqE_iYiuj8gPYoCYdtcPK7dVDtR4",
        },
      });

      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        const {
          gameType,
          player_name,
          playerId,
          player_image,
          player2_name,
          player2_image,
          instanceId,
          difficulty,
          iat,
          exp,
        } = decodeToken();
        handleApiClose(instanceId, "bot");
        // Dispose your WebGL game here
        window?.app?.postMessage("close");
        // window?.FlutterInappwebview?.callSHandler("app", "close");
        console.log("ALERTS");
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const handleGameOver = useCallback((data) => {
    console.log(data, "DATA");
    window?.ReactNativeWebView?.postMessage("close");
    window?.app?.postMessage("close");
    window?.FlutterInappwebview?.callHandler("app", "close");
    // window?.close()
    // alert("CLOSE")
    // setShow(false);
  }, []);

  useEffect(() => {
    addEventListener("GameOver", handleGameOver);
    return () => {
      removeEventListener("GameOver", handleGameOver);
    };
  }, [addEventListener, removeEventListener, handleGameOver]);

  useEffect(() => {
    if (token) {
      verifyToken();
    }
  }, [token]);

  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 8000);
  }, []);

  useEffect(() => {
    if (isLoaded) {
      requestFullscreen();
      //   setTimeout(() => {
      try {
        const {
          gameType,
          player_name,
          playerId,
          player_image,
          player2_name,
          player2_image,
          instanceId,
          difficulty,
          iat,
          exp,
        } = decodeToken();
        console.log(decodeToken(), "DECODED TOKEN");
        sendMessage(
          "GameAPICalls",
          "GetData",
          JSON.stringify({
            gameType: gameType,
            player_name: player_name,
            playerId: playerId,
            player_image: player_image,
            player2_name: player2_name,
            player2_image: player2_image,
            instanceId: instanceId,
            difficulty: difficulty,
            iat: iat,
            exp: exp,
          })
        );
        console.log("DATA PASSED IN");
      } catch (err) {
        console.error(err);
        window?.ReactNativeWebView?.postMessage("close");
        window?.app?.postMessage("close");
        window?.FlutterInappwebview?.callHandler("app", "close");
      }
      //   }, 2000);
    }
  }, [isLoaded, payload]);

  function handleMessageFromUnity(message) {
    console.log(message, "MESS");
  }
  return (
    <div className="overflow-hidden h-screen">
      {isLoaded === false && (
        // We'll conditionally render the loading overlay if the Unity
        // Application is not loaded.
        <div className="h-screen w-screen flex items-center justify-center">
          {iOS() ? (
            <img className="max-w-xs" src={gif} alt="" />
          ) : (
            <video
              className="max-w-xs"
              src={splash}
              playsInline
              autoPlay
              muted
              loop
            />
          )}
        </div>
      )}
      <div className="h-screen flex items-center justify-center bg-black">
        {verified && (
          <Unity
            unityProvider={unityProvider}
            style={{ width: "100vw", height: 650 }}
            devicePixelRatio={devicePixelRatio}
            onMessage={handleMessageFromUnity}
          />
        )}
      </div>
      {/* {isLoaded === false && (
        // We'll conditionally render the loading overlay if the Unity
        // Application is not loaded.
        <div className="loading-overlay">
          <p>Loading Game... ({loadingPercentage}%)</p>
        </div>
      )} */}
      {/* {show === false && (
        <>
          {isLoaded === false && (
            // We'll conditionally render the loading overlay if the Unity
            // Application is not loaded.
            <div className="h-screen w-screen flex items-center justify-center">
              <video
                className="max-w-xs"
                src={splash}
                playsInline
                autoPlay
                muted
                loop
              />
            </div>
          )}
        </>
      )} */}
      {/* <button onClick={setData}>Click</button> */}
      {/* {
        isLoaded === true && */}
      {/* } */}
    </div>
  );
};

export default DiscFootballUs;
